var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-result"},[_vm._t("img",function(){return [_c('img',{attrs:{"src":"img/noResult.png"}})]}),_vm._t("default"),_c('span',{staticStyle:{"height":"100%","display":"inline-block","width":"0px","vertical-align":"middle"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }